<template>
  <header class="header" :class="{autoHide: autoHide, show: showHeader}" :style="styles">
    <div class="header__menu">
      <div class="header__menu--left">
        <humburger-button :click-status="showDrawerMenu" @clicked="showDrawer" v-if="!hideControls"/>
        <a href="/" class="header__logo"><img class="header__logo__img" :class="{'hide-controls':hideControls}" src="/static/img/common/header/uranaitv_logo.svg" /></a>
      </div>
      <div class="header__menu--right" v-if="!hideControls">
        <icon-base class="accountBtn" v-if="isLoggedIn" :name="showAccountModal ? 'CloseIcon' :'AccountIcon'" :width="25" :height="25" color="white" @clicked="showAccount(!showAccountModal)"/>
        <a v-else :href="`/user/login?show=signin?return_path=${location}`" class="header__menu__noLogin">ログイン</a>
      </div>
    </div>
    <drawer v-if="showDrawerMenu" :is-logged-in="isLoggedIn" :menu-list="menuList" :color-scheme="colorScheme" />
    <account-modal v-if="showAccountModal" @close="showAccount(false)" :color-scheme="colorScheme" />
  </header>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import { MENU } from './const.js'
import Drawer from './Drawer'
import AccountModal from './AccountModal'
import IconBase from './icon/IconBase'
import HumburgerButton from './HumburgerButton'

export default {
  name: 'drawerHeader',
  components:{
    Drawer,
    AccountModal,
    IconBase,
    HumburgerButton
  },
  props: {
    autoHide: {
      type: Boolean,
      default: false,
    },
    hideControls: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      location: window.location.href,
      showHeader: false,
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
    ...mapState({
      subscInfo: state => state.account.subscription,
      showAccountModal: state => state.uiState.showAccountModal,
      showDrawerMenu: state => state.uiState.showDrawerMenu,
      isPc: state => state.uiState.isPc,
      colorScheme: state => state.recommend.colorScheme,
    }),
    menuList(){
      return !this.isLoggedIn ? MENU.NO_MEMBER : !!parseInt(this.subscInfo.active) ? MENU.SUBSC : MENU.ID
    },
    styles(){
      const initcol_keycolor = '#ff7497'
      const initcol_second = '#cb8bff'
      return {
        '--key-color': !!this.colorScheme && !!this.colorScheme.keyColor ? this.colorScheme.keyColor : initcol_keycolor,
        '--second': !!this.colorScheme && !!this.colorScheme.second ? this.colorScheme.second : initcol_second,
        '--grad-start': !!this.colorScheme && !!this.colorScheme.gradStart ? this.colorScheme.gradStart : initcol_keycolor,
        '--grad-end': !!this.colorScheme && !!this.colorScheme.gradEnd ? this.colorScheme.gradEnd : initcol_second,
        '--base-bg': !!this.colorScheme && !!this.colorScheme.baseBg ? this.colorScheme.baseBg :
          `linear-gradient(86.51deg, ${!!this.colorScheme.gradStart ? this.colorScheme.gradStart : initcol_keycolor} 21.4%, ${!!this.colorScheme.gradEnd ? this.colorScheme.gradEnd : initcol_second} 76.64%)`
      }
    },
  },
  created(){
    this.$store.dispatch(type.DRAWER_MENU_VISIBILITY, false)
    this.$store.dispatch(type.ACCOUNT_MODAL_VISIBILITY, false)
  },
  mounted() {
    if(this.autoHide){
      window.addEventListener('scroll', this.onScroll)
      setTimeout(()=>this.onScroll(), 500)
    }
  },
  methods: {
    onScroll(){
      if(this.autoHide) this.showHeader = !(window.scrollY > 140 && !(this.showDrawerMenu || this.showAccountModal))
    },
    showDrawer(isShow){
      this.$store.dispatch(type.DRAWER_MENU_VISIBILITY, isShow)
      if(isShow) this.$store.dispatch(type.ACCOUNT_MODAL_VISIBILITY, false)
    },
    showAccount(isShow){
      this.$store.dispatch(type.ACCOUNT_MODAL_VISIBILITY, isShow)
      if(isShow) this.$store.dispatch(type.DRAWER_MENU_VISIBILITY, false)
    },
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
$l_base_bg: var(--base-bg);

.header{
  position: fixed;
  height: 44px;
  width: 100%;
  z-index: 90001;
  background: $l_base_bg;
  top: 0;
  left: 0;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
  @include mq('pc') {
    z-index: 90002;
  }

  &__logo{
    display: contents;
    &__img{
      margin-left: 30px;
      width: 48px;
      vertical-align: middle;
      &.hide-controls{
        margin-left: 0;
      }
    }
  }

  &__menu{
    height: 100%;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;

    &__noLogin{
      font-size: 13px;
      font-weight: bold;
      color: $col_white;
      text-decoration: none;
      cursor: pointer;
    }
    &--left{
      position: relative;
      display: flex;
      align-items: center;

    }
    &--right{
      align-items: center;
      display: flex;
      .accountBtn{
        cursor: pointer;
      }
    }

  }
  &.autoHide {
    pointer-events: none;
    background: transparent;
    box-shadow: none;
    .header__menu {
      transform: translate(0, -100%);
      transition: transform 300ms linear 0s;
      background: $l_base_bg;
      pointer-events: auto;
    }
    &.show {
      .header__menu {
        transform: translate(0, 0);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/DrawerHeader.vue